module.exports = __webpack_public_path__ + "img/cfa9ae04541bd10fb632a62eba0e1799e82aa7a8.06239d76.gif";